import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";
import { connectWS, disconnectWS } from "./ws";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("btp_user") || "null"); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("btp_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => { setUser(r.data); localStorage.setItem("btp_user", JSON.stringify(r.data)); connectWS(); })
      .catch(() => { localStorage.removeItem("btp_token"); localStorage.removeItem("btp_user"); setUser(null); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("btp_token", r.data.token);
    localStorage.setItem("btp_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    connectWS();
    return r.data.user;
  };

  const register = async (payload) => {
    const r = await api.post("/auth/register", payload);
    localStorage.setItem("btp_token", r.data.token);
    localStorage.setItem("btp_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    connectWS();
    return r.data.user;
  };

  const logout = () => {
    disconnectWS();
    localStorage.removeItem("btp_token");
    localStorage.removeItem("btp_user");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
